import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { QuizRoutingModule } from './quiz-routing.module';
import { QuizComponent } from './quiz.component';
import { QuizService } from './quiz.service';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { AgGridModule } from 'ag-grid-angular';
import { CreateQuizComponent } from './create-quiz/create-quiz.component';
import { QuizFormComponent } from './quiz-form/quiz-form.component';
import { QuizQuestionFormComponent } from './quiz-question-form/quiz-question-form.component';
import { QuizAnswerFormComponent } from './quiz-answer-form/quiz-answer-form.component';

@NgModule({
  imports: [
    GridComponentsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    AgGridModule.withComponents([]),
    QuizRoutingModule
  ],
  declarations: [
    QuizComponent,
    CreateQuizComponent,
    QuizFormComponent,
    QuizQuestionFormComponent,
    QuizAnswerFormComponent,
  ],
  providers: [QuizService],
  exports: [QuizComponent, CreateQuizComponent]
})
export class QuizModule { }



// WEBPACK FOOTER //
// ./src/app/pages/quiz/quiz.module.ts